import type { StatusTone } from '@vnetwork/ui/data';
import type { ProjectStatus, ProjectTeamRole } from '@/api/projects';

export { formatDate, formatDateTime } from '@/lib/format-date';

/** StatusPill tone for a project lifecycle status. */
export const PROJECT_STATUS_TONE: Record<ProjectStatus, StatusTone> = {
  active: 'success',
  suspended: 'warning',
  archived: 'muted',
};

export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  active: 'Active',
  suspended: 'Suspended',
  archived: 'Archived',
};

type BadgeTone = 'neutral' | 'primary' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

/** Badge tone for a project-team role. */
export const ROLE_TONE: Record<ProjectTeamRole, BadgeTone> = {
  owner: 'primary',
  admin: 'accent',
  member: 'neutral',
  viewer: 'info',
};

export const ROLE_LABEL: Record<ProjectTeamRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
  viewer: 'Viewer',
};

/** Roles allowed to manage a project (edit info, manage teams). */
export function canManage(role: ProjectTeamRole | undefined): boolean {
  return role === 'owner' || role === 'admin';
}
